import React from 'react';

import { cf } from './c_20210427a_YSh/cf';
import { ce } from './c_20210427a_YSh/ce';
import { iv } from './c_20210427a_YSh/iv';
import { ic } from './c_20210427a_YSh/ic';
import { bf } from './c_20210427a_YSh/bf';
import { cp } from './c_20210427a_YSh/cp';
import { ip } from './c_20210427a_YSh/ip';

import cView from './c_20210427a_YSh/cView';

export default class iMngInp extends cView {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  };

  $id_stss = {
    s_cm40c310: '',
    sdd_it10ss: {},
    sld_chkIss: [],
    sld_rdrIss: [],
    sld_lineIss: [],
    sld_caseIss: [],
//    sgcn_tab: 4,
    s_it20c310: bf.myDT_get_now().substr(0,10),
    sld_it20ss: [],
    sldd_chtIsss: [],
    sld_cm10ss: [],
    s_cm10_key: -1,
    s_mngCtg_key: -1,
  };

  $ilp_bfrLoads = () => [
    cp.$cp_hlr_cm10({ // 回答者列 回答登録済のもののみ
      mode: 'items',
      state: 'sld_cm10ss',
      cnd: bf.q(`
        [cm10b21k]="{}" AND
        (
          [_KEY] IN (
            SELECT
              [it30b51k]::NUMERIC::INTEGER
            FROM
              [t_it30]
            WHERE
              [it30b11k]="{}" AND
              [it30b21k]="{}" AND
              IFNULL([it30cz10],"10")<>"0"
          ) OR
          [_KEY]={}
        ) AND
        IFNULL([cm10cz10],"10")<>"0"
      `.f(
        global.c?.state.sgcd_pagePntKeys.cm20_key,
        global.c?.state.sgcd_pagePntKeys.cm20_key,
        global.c?.state.sgc_pageKey,
        global.c?.state.sgcd_pagePntKeys.cm10_key,
      )),
      ld_sortss: [{fld:'cm10cx10', dtn:'asc', mode:'nmb'}],
    }),
    new Promise( _o_end1 => {
      global.c?.setState({
        s_cm10_key: global.c?.state.sgcd_pagePntKeys.cm10_key,
      }, () => {
bf.l('71: {}'.f(global.c?.state.s_cm10_key))
        global.c?._op_updIt20ss() // 口頭登録後の更新に必要
        .then(() => {
          _o_end1();
        });
      });
    }),
  ];

  $ilp_loads = () => [
    cp.$cp_hlr_cm40({ // 分類情報
      mode: 'set',
      b_clr: false,
      cnd: bf.q(`
        [cm40b11k]="{}" AND 
        [_KEY]={}
      `.f(
        global.c?.state.sgcd_pagePntKeys.cm20_key,
        global.c?.state.sgc_pageKey,
      )),
    }),
    global.c?._op_load1(),
    global.c?._op_load21(),
    global.c?._op_load22(),
    global.c?._op_load3(),
  ];

_op_load1 = () => cf.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_chkIss',
  dd_elmDefss: {
    cm40: { // alias
      elm: 'cm40',
      o_cnd: _dd_prtss => {
        let _cnd = bf.q(`
          [cm40b11k]="{}" AND 
          [cm40l11e]="mngCtg" AND 
          [cm40l11k]="{}" AND 
          IFNULL([cm40cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          global.c?.state.sgc_pageKey,
        ));
        return _cnd;
      },
      ld_sortss: [
        { fld: 'cm40cx10', 'dtn': 'asc', 'mode': 'str'},
      ],
      dd_cldDefss: {
        it10: { // alias
          elm: 'it10',
          o_cnd: _dd_prtss => {
            let _cnd = bf.q(`
              [it10b11k]="{}" AND 
              [it10l11e]="mngChk" AND 
              [it10l11k]="{}" AND 
              IFNULL([it10cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _dd_prtss.cm40.d_flds._KEY,
            ));
            return _cnd;
          },
          ld_sortss: [
            { fld: 'it10cx10', 'dtn': 'asc', 'mode': 'str'},
          ],
          dd_cldDefss: {
            it30: { // alias
              elm: 'it30',
              o_cnd: _dd_prtss => {
/*
                let _cnd = bf.q(`
                  [it30b11k]="{}" AND 
                  [it30b21k]="{}" AND 
                  [it30b31k]="{}" AND 
                  [it30b41k]="{}" AND 
                  [it30b51k]="{}" AND 
                  IFNULL([it30cz10],"10")<>"0"
                `.f(
                  global.c?.state.sgcd_pagePntKeys.cm20_key,
                  global.c?.state.sgc_pageKey,
                  global.c?.state.s_it20_key,
                  _dd_prtss.it10.d_flds._KEY, 
                  global.c?.state.sgcd_pagePntKeys.cm10_key,
                  global.c?.state.s_cm10_key,
                ));
*/
//                  [it30b31k]="${global.c?.state.s_it20_key}" AND 
                let _cnd = bf.q(`
                  [it30b11k]="${global.c?.state.sgcd_pagePntKeys.cm20_key}" AND 
                  [it30b21k]="${global.c?.state.sgc_pageKey}" AND 
                  [it30b31k]=(
                    SELECT
                      [_KEY]::TEXT
                    FROM
                      t_it20
                    WHERE
                      it20b11k = "${global.c?.state.sgcd_pagePntKeys.cm20_key}" AND 
                      it20b21k = "${global.c?.state.sgc_pageKey}" AND 
                      it20c310 = "${global.c?.state.s_it20c310}"
                  ) AND 
                  [it30b41k]="${_dd_prtss.it10.d_flds._KEY}" AND 
                  [it30b51k]="${global.c?.state.sgcd_pagePntKeys.cm10_key}" AND 
                  IFNULL([it30cz10],"10")<>"0"
                `);
                return _cnd;
              },
            },
          },
        },
      },
    },
  },
});

_op_load4 = () => cf.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_chkIss2',
  dd_elmDefss: {
    cm40: { // alias
      elm: 'cm40',
      o_cnd: _dd_prtss => {
        let _cnd = bf.q(`
          [cm40b11k]="{}" AND 
          [cm40l11e]="mngCtg" AND 
          [cm40l11k]="{}" AND 
          [_KEY]={} AND 
          IFNULL([cm40cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          global.c?.state.sgc_pageKey,
          global.c?.state.s_mngCtg_key,
        ));
        return _cnd;
      },
      ld_sortss: [
        { fld: 'cm40cx10', 'dtn': 'asc', 'mode': 'str'},
      ],
      dd_cldDefss: {
        it10: { // alias
          elm: 'it10',
          o_cnd: _dd_prtss => {
            let _cnd = bf.q(`
              [it10b11k]="{}" AND 
              [it10l11e]="mngChk" AND 
              [it10l11k]="{}" AND 
              IFNULL([it10cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _dd_prtss.cm40.d_flds._KEY,
            ));
            return _cnd;
          },
          ld_sortss: [
            { fld: 'it10cx10', 'dtn': 'asc', 'mode': 'str'},
          ],
          dd_cldDefss: {
            it30: { // alias
              elm: 'it30',
              o_cnd: _dd_prtss => {
                let _cnd = bf.q(`
                  [it30b11k]="${global.c?.state.sgcd_pagePntKeys.cm20_key}" AND 
                  [it30b21k]="${global.c?.state.sgc_pageKey}" AND 
                  [it30b31k]="${global.c?.state.s_it20_key}" AND 
                  [it30b41k]="${_dd_prtss.it10.d_flds._KEY}" AND 
                  [it30b51k]="${global.c?.state.s_cm10_key}" AND 
                  IFNULL([it30cz10],"10")<>"0"
                `);
//bf.l('216: {}'.f(_cnd))
                return _cnd;
              },
            },
          },
        },
      },
    },
  },
});

_op_load21 = () => cf.myCB_call_tree({ // 事例
  ctr: 'slc',
  state: 'sdld_caseIss1',
  dd_elmDefss: {
    it10: { // alias
      elm: 'it10',
      o_cnd: _dd_prtss => {
        let _cnd = bf.q(`
          [it10b11k]="{}" AND 
          [it10l11e]="mngCase" AND 
          [it10l11k]="{}" AND 
          [it10t110]="20" AND 
          IFNULL([it10cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          global.c?.state.sgc_pageKey,
        ));
        return _cnd;
      },
    },
  },
});

_op_load22 = () => cf.myCB_call_tree({ // 事例
  ctr: 'slc',
  state: 'sdld_caseIss2',
  dd_elmDefss: {
    it10: { // alias
      elm: 'it10',
      o_cnd: _dd_prtss => {
        let _cnd = bf.q(`
          [it10b11k]="{}" AND 
          [it10l11e]="mngCase" AND 
          [it10l11k]="{}" AND 
          (
            [it10t110]="10" AND 
            [it10b21k]="{}"
          ) AND
          IFNULL([it10cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          global.c?.state.sgc_pageKey,
          global.c?.state.sgcd_pagePntKeys.cm10_key,
        ));
        return _cnd;
      },
    },
  },
});

_op_load3 = () => cf.myCB_call_tree({ // チェック項目分類
  ctr: 'slc',
  state: 'sdld_cm40sss',
  dd_elmDefss: {
    cm40: { // alias
      elm: 'cm40',
      o_cnd: _dd_prtss => {
        let _cnd = bf.q(`
          [cm40b11k]="{}" AND 
          [cm40l11e]="mngCtg" AND 
          [cm40l11k]="{}" AND 
          IFNULL([cm40cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          global.c?.state.sgc_pageKey,
        ));
        return _cnd;
      },
    },
  },
  op_atr: () => new Promise( _o_end1 => {
    let _n_mngCtg_key = bf.f(global.c?.state.sdld_cm40sss?.cm40) ? global.c?.state.sdld_cm40sss?.cm40[0].d_flds._KEY : -1;
    global.c?.setState({
      s_mngCtg_key: _n_mngCtg_key,
    }, () => {
      _o_end1();
    });
  }),
});

$ip_ins = () => null;

$ilp_upds = () => [
  new Promise( _o_end1 => {
    if (global.c?.state.sgcn_tab == 4) { // チャートタブの場合
      let _d_vals = {
        it20b11k: global.c?.state.sgcd_pagePntKeys.cm20_key,
        it20b21k: global.c?.state.sgc_pageKey,
        it20c310: global.c?.state.s_it20c310,
      };
      let _cnd = bf.q(`
        [it20b11k]="{}" AND 
        [it20b21k]="{}" AND 
        [it20c310]="{}"
      `.f(
        global.c?.state.sgcd_pagePntKeys.cm20_key,
        global.c?.state.sgc_pageKey,
        global.c?.state.s_it20c310,
      ));
//bf.l('341: {}, {}'.f(_cnd, _d_vals));
      ip.$ip_hlr_it20({
        mode: 'ups',
        d_vals: _d_vals,
        cnd: _cnd,
      })
      .then( _n_it20_key => {
//bf.l('348: {}'.f(_n_it20_key));
//bf.l('349: {}'.f(global.t?.state.sdld_chkIss));
        cf.myCB_call_tree({
          ctr: 'iud',
          state: 'sdld_chkIss',
          dd_elmDefss: {
            cm40: {
              dd_cldDefss: {
                it10: {
                  dd_cldDefss: {
                    it30: {
                      od_insDats: _dd_datss => {
                        let _d = {
                          it30b11k: global.c?.state.sgcd_pagePntKeys.cm20_key,
                          it30b21k: global.c?.state.sgc_pageKey,
                          it30b31k: _n_it20_key,
                          it30b41k: _dd_datss.it10.d_flds._KEY,
                          it30b51k: global.c?.state.sgcd_pagePntKeys.cm10_key,
                          it30c610: _dd_datss.it30.d_flds.it30c610,
                        };
//bf.l('367: {}'.f(_d));
                        return _d;
                      }
                    },
                  },
                },
              },
            },
          },
        })
        .then(() => {
          _o_end1(); 
        });
      });
      //_o_end1();    
    };
    if (global.c?.state.sgcn_tab == 5) { // 事例タブの場合
      cf.myCB_call_tree({
        ctr: 'iud',
        state: 'sdld_caseIss2',
        dd_elmDefss: {
          it10: {
            od_insDats: pd => {
              let _d = {
                it10b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0', // 追加
                it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0', // 追加
                it10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0', // 追加
                it10l11e: 'mngCase',
                it10l11k: global.c?.state.sgc_pageKey,
                it10c110: '',
                it10c310: pd.it10.d_flds.it10c310,
                it10cz10: '10', // 表示 
/*
                it10t110: ip.$o_pmn({ // 追加
                  mode: 'type',
                }),
*/
                it10t110: '10',
                it10cw10: pd.it10.d_flds.it10cw10 || bf.myCM_gnr(10),
                it10cy10: bf.myDT_get_now(), // 追加
                it10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '', // 追加
              };
              return _d;
            },
          },
        },
      })
      .then(() => {
        _o_end1(); 
      });
    };
  }),
];

  $cld_onChgss = cp.cld_onChgss;

  $ild_onChgss = () => [
  ];

_op_drawRdr = (pd={
}) => new Promise( _o_end1 => {

  let _qry = bf.q(`
    SELECT
      [it10c310] AS [fld],
      IFNULL((
        SELECT
          [it30c610]
        FROM
          [t_it30]
        WHERE
          [it30b11k]="{}" AND 
          [it30b21k]="{}" AND 
          [it30b31k]="{}" AND 
          [it30b41k]=[t_it10].[_KEY]::TEXT AND
          [it30b51k]="{}" AND 
          IFNULL([it30cz10],"10")<>"0"
      ),"0")::NUMERIC::INTEGER AS [val]
    FROM
      [t_it10]
    WHERE
      [it10b11k]="{}" AND 
      [it10l11e]="mngChk" AND 
      [it10l11k]="{}" AND 
      IFNULL([it10cz10],"10")<>"0"
    ORDER BY
      [it10cx10], [it10cw10]
  `.f(
    global.c?.state.sgcd_pagePntKeys.cm20_key,
    global.c?.state.sgc_pageKey,
    global.c?.state.s_it20_key,
    global.c?.state.s_cm10_key,
    global.c?.state.sgcd_pagePntKeys.cm20_key,
    global.c?.state.s_mngCtg_key,
  ));
//[it10cx10], 

  cf.myCB_call_slc({ // 中項目（チェック項目分類）
    ctr: 'qry', 
    elm: 'it10', 
    n_dms: 3, 
    qry: _qry,
  })
  .then( _ld_it10ss => {

    let _l3 = _ld_it10ss
    .map( (_d_is, _idx) => {
      let _r = {
        fld: '({})'.f(_idx+1),
        val: bf.n(_d_is.val) || 0,
      };
      return _r;
    });

    let _ttl = _l3
    .reduce( (_prev, _d_is) => { // it10
      return _prev + bf.n(_d_is.val)
    }, 0);

    let _max = _l3
    .reduce( (_prev, _d_is) => { // it10
      return _prev + 4
    }, 0);

    let _d = {
      type: 'rdr',
      pfx: '時点情報 ({}/{}点)'.f(_ttl, _max),
      ld_iss: _l3,
      d_defs: {
        n_minVal: 0,
        n_maxVal: 5,
        d_valLbls: {
          4: '', 
          3: '', 
          2: '', 
          1: '',
        },
      },
    };

    global.c?.setState({
      sldd_chtIsss: bf.p(global.c?.state.sldd_chtIsss, _next => {
        if (bf.f(_next) == false) _next.push({line:{}, rdr:{}});
        _next[0].rdr = _d;
      }),
    }, () => {
      _o_end1();
    })

  });
});

_op_drawLine = (pd={
}) => new Promise( _o_end1 => {

  let _qry = bf.q(`
    SELECT 
      [t_it20].[_KEY] AS [it20_key],
      [t_it20].[it20c310] AS [fld],
      IFNULL((
        SELECT
          SUM(IFNULL([it30c610],"0")::NUMERIC::INTEGER)
        FROM
          [t_it30]
        WHERE
          [it30b11k]=[it20b11k] AND
          [it30b21k]=[it20b21k] AND
          [it30b31k]=[t_it20].[_KEY]::TEXT AND
          [it30b41k] IN (
            SELECT
              [t_it10].[_KEY]::TEXT
            FROM
              [t_it10]
            WHERE
              [t_it10].[it10b11k]="{}" AND
              [t_it10].[it10l11e]="mngChk" AND 
              [t_it10].[it10l11k]="{}" AND
              IFNULL([it10cz10],"10")<>"0"
          ) AND
          [it30b51k]="{}" AND
          IFNULL([it30cz10],"10")<>"0"
      ),0) AS [val],
      (
        SELECT
          COUNT(*) * 4
        FROM
          [t_it10]
        WHERE
          [t_it10].[it10b11k]="{}" AND
          [t_it10].[it10l11e]="mngChk" AND 
          [t_it10].[it10l11k]="{}" AND
          IFNULL([it10cz10],"10")<>"0"
      ) AS [max]
    FROM 
      [t_it20] 
    WHERE 
      [t_it20].[_KEY] IN (
        SELECT
          [t_it30].[it30b31k]::NUMERIC::INTEGER
        FROM
          [t_it30]
        WHERE
          [it30b11k]="{}" AND
          [it30b21k]="{}" AND
          [it30b51k]="{}" AND
          IFNULL([it30cz10],"10")<>"0"
      ) AND
      IFNULL([it20cz10],"10")<>"0"
    ORDER BY
      [fld]
  `.f(
    global.c?.state.sgcd_pagePntKeys.cm20_key,
    global.c?.state.s_mngCtg_key,
    global.c?.state.s_cm10_key,
    global.c?.state.sgcd_pagePntKeys.cm20_key,
    global.c?.state.s_mngCtg_key,
    global.c?.state.sgcd_pagePntKeys.cm20_key,
    global.c?.state.sgc_pageKey,
    global.c?.state.s_cm10_key,
  ));

  cf.myCB_call_slc({ // 中項目（チェック項目分類）
    ctr: 'qry', 
    elm: 'it30', 
    n_dms: 3, 
    qry: _qry,
  })
  .then( _ld_it30ss => {

    let _n_max = _ld_it30ss.reduce( (_prev, _d_it30s) => {
      return (_d_it30s.max > _prev) ? _d_it30s.max : _prev;
    }, 0);

    let _d = {
      type: 'line',
      pfx: '履歴情報 (全{}点)'.f(_n_max),
      ld_iss: _ld_it30ss,
      d_defs: {
        n_minVal: 0,
        n_maxVal: _n_max,
        stlDot:{ 
          fill: _d_ps => {
//            return ( _ld_it30ss[_d_ps.index].it20_key == global.c?.state.s_it20_key ) ? '#fd7e00' : '#3ab60b';
            return ( _ld_it30ss[_d_ps.index].it20_key == global.c?.state.s_it20_key ) ? 'orange' : 'orange';
          }
        },
      },
      onPrs: (_d_ids, _idx) => {
        let _it20_key = _ld_it30ss[_idx]?.it20_key || -1;
        if ( _it20_key > -1 ) {
          global.c?.setState({
            s_it20_key: _it20_key,
          })
        };
      },
    };

    global.c?.setState({
      sldd_chtIsss: bf.p(global.c?.state.sldd_chtIsss, _next => {
        if (bf.f(_next) == false) _next.push({line:{}, rdr:{}});
        _next[0].line = _d;
      }),
    }, () => {
      _o_end1();
    });
  });
});

  $pld_onChgss = () => [

  ];

  _op_updIt20_key = () => new Promise( _o_end1 => {
    let _it20_key = bf.f(global.c?.state.sld_it20ss) ? global.c?.state.sld_it20ss[0].key : -1;
    global.c?.setState({
      s_it20_key: _it20_key,
    }, () => {
      _o_end1();
    });
  });

  _op_updIt20ss = () => new Promise( _o_end1 => {
    let _cnd = bf.q(`
      [it20b11k]="{}" AND
      [it20b21k]="{}" AND
      (
        SELECT 
          COUNT(*) 
        FROM 
          [t_it30] 
        WHERE 
          [t_it30].[it30b11k]="{}" AND
          [t_it30].[it30b21k]="{}" AND
          [t_it30].[it30b31k]=[t_it20].[_KEY]::TEXT AND 
          [t_it30].[it30b51k]="{}"
      )>0
    `.f(
      global.c?.state.sgcd_pagePntKeys.cm20_key,
      global.c?.state.sgc_pageKey,
      global.c?.state.sgcd_pagePntKeys.cm20_key,
      global.c?.state.sgc_pageKey,
      global.c?.state.s_cm10_key,
    ));
bf.l('684: {}'.f(_cnd));
    ip.$ip_hlr_it20({
      mode: 'items',
      state: 'sld_it20ss',
      cnd: _cnd,
      ld_sortss: [{fld:'it20c310', dtn:'desc'}],
    })
    .then(() => {
bf.l('692: {}'.f(global.c?.state.sld_it20ss));
      _o_end1();
    })
  });

  $pdo_onChgs = {
    sgc_pageMode: () => { // 編集モード
      if ( global.c?.state.sgc_pageMode == 'edit' ) {
        global.c?.setState({
          s_cm10_key: global.c?.state.sgcd_pagePntKeys.cm10_key,
        })
      }
    },
    s_cm10_key: () => { // 回答者
      global.c?._op_updIt20ss();　// 回答日列
      global.c?._op_drawLine();　// 履歴情報
    },
    sld_it20ss: () => { // 回答日列
      global.c?._op_updIt20_key();　// 回答日
    },
    s_it20_key: () => { // 回答日
//      global.c?._drawLine();　// 履歴情報
      global.c?._op_drawRdr();　// 回答日
      global.c?._op_load4();　// 時点情報
    },
    s_mngCtg_key: () => { // チェック分類
      global.c?._op_drawLine();　// 履歴情報
      global.c?._op_drawRdr();　// 時点情報
      global.c?._op_load4();　// 時点情報
    },
  };

  render() {

//          b_rhtVsb={(global.c?.state.s_cm10_key != global.c?.state.sgcd_pagePntKeys.cm10_key) ? false : ((global.c?.state.sgc_pageMode == 'edit') ? false : true)}
//          rhtPfx={(global.c?.state.sgc_pageMode == 'edit') ? '登録・反映' : '回答・変更'}
//bf.l('716: {}'.f(global.c?.state.sgc_pageMode))
//bf.l('717: {}'.f(global.c?.state.s_it20c310));
    return (
      <this.$onChg>
        <ce.RootDtl
          key={-1}
          b_logo={false}
          b_rhtVsb={
            (global.c?.state.s_cm10_key != global.c?.state.sgcd_pagePntKeys.cm10_key) ? 
              false 
            : (global.c?.state.sgcn_tab == 4 && global.c?.state.sgc_pageMode == 'edit') ? 
              false 
            : true
          }
          rhtPfx={
            bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) ?
              '反映'
            :
              '回答・登録・変更'
          }
          rhtIconName={(global.c?.state.sgc_pageMode == 'edit') ? 'check' : 'pencil'} 
          onRhtPrs={
            (global.c?.state.sgc_pageMode == 'edit') ?
              () => {
                cf.myRN_set_pageMode('edit');                
              }
            : null
          }
          d_hdrs={{
            pfx:  iv._get_hdrPfx('チェックシート回答情報'),
            d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgc_pageMode),
            d_subMenus: {
              b_vsb: false,
            },
          }}
          d_bdys={{
            ld_defss: [
              {
                type:'Inp',
                b_vsb: true,
                b_edt: false,
                state:'s_cm40c310',
                pfx:'シート名',
                b_mln:false,
              },

              {
                type:'Pck',
                b_vsb: (global.c?.state.sgcn_tab == 4) ? true : false,
                b_edt: ( global.c?.state.sgc_pageMode == 'edit' || !bf.f(global.c?.state.sld_cm10ss) ) ? false : true,
                state:'s_cm10_key',
                pfx: '回答者',
                phd: !bf.f(global.c?.state.sld_cm10ss) ? '回答者が存在しません' : '回答者を選択ください',
                b_mln:false,
                ld_iss: global.c?.state.sld_cm10ss
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgc_pageMode == 'edit' && global.c?.state.sgcn_tab == 4) ? true : false,
                b_edt: false,
                state:'s_it20c310',
                pfx:'回答日',
                b_mln:false,
              },
              {
                type:'Pck',
                b_vsb: (global.c?.state.sgc_pageMode == 'show' && global.c?.state.sgcn_tab == 4) ? true : false,
                b_edt: (bf.f(global.c?.state.sld_it20ss)) ? true : false,
                ld_iss: global.c?.state.sld_it20ss,
                state: 's_it20_key',
                pfx:'回答日',
                phd: (!bf.f(global.c?.state.sld_it20ss)) ? '回答が存在しません' : '回答日を選択ください',
                b_mln:false,
                onChg: null,
              },

              {
                type: 'Btns',
                b_vsb: (global.c?.state.sgc_pageMode == 'show' && global.c?.state.sgcn_tab == 4 && bf.f(global.c?.state.sld_it20ss)) ? true : false,
                pfx: 'チャート',
                b_srl: true,
                old_defss: () => {
                  return global.c?.state.sdld_cm40sss?.cm40
                  .map( _d_cm40s => {
                    let _d = {
                      key: _d_cm40s.d_flds._KEY,
                      pfx: _d_cm40s.d_flds.cm40c310,
                      onPrs: _d_vals => {
                        global.c?.setState({
                          s_mngCtg_key: _d_cm40s.d_flds._KEY,
                        });
                      },
                    }
                    return _d;
                  })
                },
              },

              {
                type: 'Chts',
                b_vsb: (global.c?.state.sgc_pageMode == 'show' && global.c?.state.sgcn_tab == 4 && bf.f(global.c?.state.sld_it20ss)) ? true : false,
                pfx: '',
                ldd_isss: global.c?.state.sldd_chtIsss,
              },

              {
                type: 'InpTree3',
                b_vsb: (global.c?.state.sgc_pageMode == 'show' && global.c?.state.sgcn_tab == 4 && bf.f(global.c?.state.sld_it20ss)) ? true : false, // 回答閲覧用
                b_edt: false,
                state: 'sdld_chkIss2',
                dd_elmDefss: {
                  cm40: {
                    pfx: '回答内容',
                    dd_fldDefss: {
                    },
                    dd_cldDefss: {
                      it10: {
                        b_noStep: true,
                        dd_fldDefss: {
                          it10c310: {
                            type: 'Inp',
                            b_edt: false,
                            b_dltPrs: false,
                            o_stlVal: _d_dats => {
                              return '({}) {}'.f(_d_dats.idx+1, _d_dats.d_flds.it10c310)
                            },
                          },
                        },
                        dd_cldDefss: {
                          it30: {
                            dd_fldDefss: {
                              it30c610: {
                                type: 'Pck',
                                b_edt: false,
                                phd: '回答を選択ください',
                                ld_iss: [
                                  {key:'4', pfx:'特にそう思う'},
                                  {key:'3', pfx:'そう思う'},
                                  {key:'2', pfx:'あまりそう思わない'},
                                  {key:'1', pfx:'全くそう思わない'},
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },

              {
                type: 'InpTree3',
                b_vsb: (global.c?.state.sgcn_tab == 4 && global.c?.state.sgc_pageMode == 'edit') ? true : false, // 回答登録用
                b_edt: false,
                state: 'sdld_chkIss',
                dd_elmDefss: {
                  cm40: {
                    pfx: '回答内容',
                    dd_fldDefss: {
                      cm40c310: {
                        type: 'Inp',
                        b_edt: false,
                        b_dltPrs: false,
                        stlCta: {
                          borderBottomWidth: ic.gn_bdrWNrw,
                        },
                      },
                    },
                    dd_cldDefss: {
                      it10: {
                        b_noStep: true,
                        dd_fldDefss: {
                          it10c310: {
                            type: 'Inp',
                            b_edt: false,
                            b_dltPrs: false,
                          },
                        },
                        dd_cldDefss: {
                          it30: {
                            b_noStep: true,
                            b_newLine: true,
                            d_insDats: {
                              d_flds: {
                                it30c610: '',
                              },
                            },
                            dd_fldDefss: {
                              it30c610: {
                                type: 'Pck',
                                b_edt: true,
                                phd: '回答を選択ください',
                                ld_iss: [
                                  {key:'4', pfx:'特にそう思う'},
                                  {key:'3', pfx:'そう思う'},
                                  {key:'2', pfx:'あまりそう思わない'},
                                  {key:'1', pfx:'全くそう思わない'},
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },

              {
                type: 'Btn',
                b_vsb: (global.c?.state.sgcn_tab == 4 && global.c?.state.sgc_pageMode == 'edit') ? true : false,
                pfx: '登録',
                onPrs: global.c?.upd,
                stlCta: {
                  marginBottom: ic.gn_mgnNrm,
                },
              },

              {
                type: 'InpTree3',
                b_vsb: 
                  (global.c?.state.sgcn_tab == 5 && bf.i(global.c?.state.sgc_pageMode, ['show'])) ?
                    true
                  : false
                ,
                b_edt: false,
                state: 'sdld_caseIss1',
                dd_elmDefss: {
                  it10: {
                    pfx: '失敗・クレーム事例（共通）',
                    d_insDats: {
                      d_flds: {
                        it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key,
                        it10c310: '',
                        it10t110: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? '20' : '10',
                      },
                    },
                    dd_fldDefss: {
                      it10c310: {
                        type: 'Inp',
                        b_mln: true,
                        phd: '失敗・クレーム事例を入力ください',
                        ob_vsb: _d_dats => {
                          let _b = ip.$o_pmn({
                            mode: 'vsbLine', 
                            t110: _d_dats.d_flds.it10t110,
                            b21k: _d_dats.d_flds.it10b21k,
                          });
                          return _b;
                        },
                        o_stlCta: _d_dats => {
                          let _d = {}
                          if (global.c?.state.sgc_pageMode == 'show'){
                            _d = {
                              borderWidth: 0,
                              borderLeftWidth: ic.gn_bdrWNrm,
                              borderColor: ip.$o_pmn({
                                mode: 'ccd',
                                t110: _d_dats.d_flds.it10t110,
                              }),
                            };
                          };
                          return _d;
                        },
                      },
                    },
                  },
                },
              },

              {
                type: 'InpTree3',
                b_vsb: 
                  (global.c?.state.sgcn_tab == 5) ?
                    true
                  : false
                ,
                b_edt: false,
                state: 'sdld_caseIss2',
                dd_elmDefss: {
                  it10: {
                    pfx: '失敗・クレーム事例（個人）',
                    d_insDats: 
                      (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10') ?
                        {
                          d_flds: {
                            it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key,
                            it10c310: '',
                            it10t110: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? '20' : '10',
                          },
                        }
                      : null
                    ,
                    dd_fldDefss: {
                      it10c310: {
                        type: 'Inp',
                        b_mln: true,
                        phd: '失敗・クレーム事例を入力ください',
                        b_vsb: true,
                        b_edt:
                          ( global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            true
                          : false
                        ,
                        o_stlCta: _d_dats => {
                          let _d = {}
                          if (global.c?.state.sgc_pageMode == 'show'){
                            _d = {
                              borderWidth: 0,
                              borderLeftWidth: ic.gn_bdrWNrm,
                              borderColor: ip.$o_pmn({
                                mode: 'ccd',
                                t110: _d_dats.d_flds.it10t110,
                              }),
                            };
                          };
                          return _d;
                        },
                        b_btnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            true 
                          : false
                        ,
                        btnIconName: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            'check'
                          : null
                        ,
                        onBtnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            _d_flds => {
                              if (bf.i(global.c?.state.sgc_pageMode, ['new'])) global.c?.ins();
                              if (bf.i(global.c?.state.sgc_pageMode, ['edit'])) global.c?.upd();
                            }
                          : null
                        ,
                      },
                    },
                  },
                },
              },

            ],
          }}
          d_tops={{
            b_vsb: (global.c?.state.sgc_pageMode == 'show') ? true : false,
//            b_vsb: true,
            n_h: (global.c?.state.sgc_pageMode == 'show') ? (ic.gn_fontSizeNrm + ic.gn_bdrWNrw * 2 + ic.gn_mgnNrm * 4) : 0,
            ld_defss: [
              {
                type: 'Btns',
                b_vsb: (global.c?.state.sgc_pageMode == 'show') ? true : false,
                ld_defss: [
                  {
                    pfx: 'チャート',
                    b_vsb: true,
                    b_rvs: (global.c?.state.sgcn_tab == 4) ? false : true,
                    onPrs: () => {
                      global.c?.setState({
                        sgc_pageMode: 'show',
                      }, ()=>{
                        global.c?.$onPrsTab({n_tab: 4});
                      })
                    },
                  },
                  {
                    pfx: '事例',
                    b_vsb: true,
                    b_rvs: (global.c?.state.sgcn_tab == 5) ? false : true,
                    onPrs: () => {
                      global.c?.setState({
                        sgc_pageMode: 'show',
                      }, ()=>{
                        global.c?.$onPrsTab({n_tab: 5});
                      })
                    },
                  },
                ],
                stlCta: {
                  marginTop: ic.gn_mgnLrg,
                  marginBottom: ic.gn_mgnLrg,
                },
              },
            ],
          }}
        />

      </this.$onChg>
    );
  }

}